/**
 * @fileoverview POST handler for the "/:app_group_id/knowledge_source/definition/:id/search" endpoint
 */
import type { FetchRequestError } from "@lib/errors";
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionIdSearchCacheKeys } from "./constants";
import type { SearchKnowledgeSourceDefinitionIdProps, SearchKnowledgeSourceDefinitionIdResult } from "./types";

export const postKnowledgeSourceDefinitionIdSearch = reactQueryMutationAdapter(
  knowledgeSourceDefinitionIdSearchCacheKeys,
  createMutationFetcherFunctionWithShadowError<FetchRequestError>()(
    (props: SearchKnowledgeSourceDefinitionIdProps): Promise<SearchKnowledgeSourceDefinitionIdResult> => {
      return fetch(
        `/${props.appGroupId}/knowledge_source/definition/${props.definitionId}/search`,
        "POST",
        {
          query: props.query,
          filters: props.filters,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
